// ===================================================================
// src/app/services/whatsapp.service.ts
//
// Serviço de integração WhatsApp da escola.
// O backend gerencia o messaging_token internamente — nunca trafega
// pelo frontend.
// ===================================================================

import { api } from './api';

export type WhatsAppStatus = 'disconnected' | 'connecting' | 'connected';

export interface WhatsAppConnectResponse {
  qr_code: string;
  status: string;
}

export interface WhatsAppStatusResponse {
  status: WhatsAppStatus;
  phone?: string;
}

export const whatsappService = {
  /**
   * Inicia o fluxo de conexão e retorna o QR code (base64) a ser escaneado.
   */
  connectWhatsApp: (): Promise<WhatsAppConnectResponse> =>
    api.post<WhatsAppConnectResponse>('/schools/whatsapp/connect/'),

  /**
   * Consulta o status atual da integração WhatsApp da escola.
   */
  getWhatsAppStatus: (): Promise<WhatsAppStatusResponse> =>
    api.get<WhatsAppStatusResponse>('/schools/whatsapp/status/'),

  /**
   * Encerra a sessão WhatsApp atual na UazAPI.
   */
  disconnectWhatsApp: (): Promise<{ status: WhatsAppStatus }> =>
    api.post<{ status: WhatsAppStatus }>('/schools/whatsapp/disconnect/'),
};
